import { AxiosResponse, AxiosError } from "axios";
import api from "@services/axios/apiManager";

//@ 取得訂單列表
export const listOrders = async ({
  jwtToken,
  xContext,
  params,
}: {
  jwtToken: string;
  xContext?: string;
  params?: { page?: number; limit?: number; status?: string };
}) => {
  const apiUrl = `/app-api/platform-orders`;

  const headers: Record<string, string> = {
    Authorization: `Bearer ${jwtToken}`,
  };

  if (xContext) {
    headers["X-Context"] = xContext;
  }

  try {
    const res: AxiosResponse = await api.get(apiUrl, {
      params,
      headers,
    });
    return { state: "success" as const, data: res.data };
  } catch (error) {
    const axiosError = error as AxiosError;
    console.error("取得訂單列表失敗:", axiosError);
    return { state: "error" as const, error: axiosError };
  }
};

//@ 取得單筆訂單詳情
export const getOrderDetails = async ({ orderId, jwtToken, xContext }: { orderId: string; jwtToken: string; xContext?: string }) => {
  const apiUrl = `/app-api/platform-orders/${orderId}`;

  const headers: Record<string, string> = {
    Authorization: `Bearer ${jwtToken}`,
  };

  if (xContext) {
    headers["X-Context"] = xContext;
  }

  try {
    const res: AxiosResponse = await api.get(apiUrl, {
      headers,
    });
    return { state: "success" as const, data: res.data };
  } catch (error) {
    const axiosError = error as AxiosError;
    console.error("取得訂單詳情失敗:", axiosError);
    return { state: "error" as const, error: axiosError };
  }
};
